import React, { useEffect, useState } from 'react';
import Cookies from 'universal-cookie';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import { fetchMobileRegcode } from 'Api/ProfileApi';
import { getDefaultConfig } from 'Utils/Store';
import './GetAppButton.css';

const cookie = new Cookies();

export const GetAppButton = ({ ctaText = '', isMobile }) => {
  const [regcode, setRegcode] = useState('');

  useEffect(() => {
    const retrieveRegcode = async (deviceId) => {
      const { code } = await fetchMobileRegcode(deviceId);
      setRegcode(`?${code}`);
    };
    if (isMobile) {
      const { deviceIdCookieName } = getDefaultConfig();
      const deviceId = cookie.get(deviceIdCookieName);
      retrieveRegcode(deviceId);
    }
  }, [isMobile]);

  const openApp = () => {
    trackEvent(
      TRACKING_ENUMS.EVENT_DEVICE_LINK_BUTTON_CLICKED,
      {
        page_item_title: 'signup confirmation',
        page_ui_element: 'button',
      },
      {
        item_title: 'signup confirmation',
        button_text: ctaText,
        ui_element: 'button',
      }
    );
    window.location.assign(`https://foxnation.onelink.me/CbbD/InstallApp${regcode}`);
  };

  if (ctaText && isMobile) {
    return (
      <div className="get-app-button-container">
        <div className="icon-image-container" onClick={openApp} role="link">
          <img src="/account/static/images/FN/FN-Icon.png" className="fn-icon" alt="Fox Nation Icon" />
        </div>
        <img
          src="/account/static/images/FN/FNDevices1.png"
          className="device-images"
          alt="Mobile Device Images"
          onClick={openApp}
        />
        <button className="get-app-button" type="button" onClick={openApp}>
          {ctaText}
        </button>
      </div>
    );
  }
  return null;
};
